export const CONSTANTS = {
    //App
    // DEFAULT_WIDTH: 1920,
    // DEFAULT_HEIGHT: 1080,
    // DEFAULT_MID_X: 1920 / 2,
    // DEFAULT_MID_Y: 1080 / 2,

    // DEFAULT_WIDTH: 3840,
    // DEFAULT_HEIGHT: 2160,
    // DEFAULT_MID_X: 3840 / 2,
    // DEFAULT_MID_Y: 2160 / 2,

    // DEFAULT_WIDTH: 1280,
    // DEFAULT_HEIGHT: 720,
    // DEFAULT_MID_X: 1280 / 2,
    // DEFAULT_MID_Y: 720 / 2,

    DEFAULT_WIDTH: 853,
    DEFAULT_HEIGHT: 480,
    DEFAULT_MID_X: 853 / 2,
    DEFAULT_MID_Y: 480 / 2,

    //Spectrum Processing
    BASS_SMOOTHING_POINTS: 5,
    WIDE_SMOOTHING_POINTS: 5,

    //WaveCircle
    BASS_BOUNCE_SCALE: 7,
    BASS_SHAKE_FACTOR_LITTLE: 250,
    BASS_SHAKE_FACTOR_LOT: 400,

    WIDE_BOUNCE_SCALE: 2,
    WIDE_SHAKE_FACTOR_LITTLE: 40,
    WIDE_SHAKE_FACTOR_LOT: 70,

    BASS_TARGET_MAX: 45,
    WIDE_TARGET_MAX: 185,

    //Background
    BACKGROUND_BOUNCE_SCALE: -1.5,
    BACKGROUND_SHAKE_FACTOR: 300,
    BACKGROUND_PADDING_FACTOR: 1.05,
    BACKGROUND_MAX_VIGNETTE: 0.2,
    BACKGROUND_VIGNETTE_FACTOR: 5,
    BACKGROUND_MAX_CONTRAST: 1.2,
    BACKGROUND_CONTRAST_FACTOR: 6,
    BACKGROUND_MAX_ZOOM_BLUR: 0.5,
    BACKGROUND_ZOOM_BLUR_FACTOR: 1.7,

    //Text
    TA1_VERTICAL_DIVISOR: 3,
    TA1_SIZE_DIVISOR: 20,
    TEXT_MAX_EXPECTED_MULTIPLIER: 5.0, // Covers 4K exports (2160 / 500 = 4.32) and beyond
    TEXT_MAX_SAFE_TEXTURE_DIM: 14000, // Safe threshold below WebGL's 16384 limit
    TEXT_BASE_WRAP_WIDTH: 2800, // Base word wrap width for text elements (TEXT_MAX_SAFE_TEXTURE_DIM / TEXT_MAX_EXPECTED_MULTIPLIER)
}

export const WAVE_STYLE = {
    SOLID: 'solid',
    BAR: 'bar',
    POINT: 'point',
    LINE: 'line'
}

// Hollow Center makes the waves start at the edge of the circle instead of its center. Only the styles
// that actually fill the center have something to hollow out: a bar radiates a wedge from the center and
// a solid fills the whole disc. Point dots and the Line outline never cover the center, so the toggle
// is hidden for them.
export const HOLLOW_CENTER_WAVE_STYLES = [WAVE_STYLE.BAR, WAVE_STYLE.SOLID];

// Shared by the global and the per-layer Hollow Center switch so both explain the feature identically.
export const HOLLOW_CENTER_TOOLTIP = 'Waves start at the edge of the circle.';

export const MOVEMENT_DIRECTION = {
    OUTWARD: 'outward',
    INWARD: 'inward'
}

export const WAVE_TYPE = {
    BASS_SPECTRUM: 'bass spectrum',
    WIDE_SPECTRUM: 'wide spectrum',
    WAVEFORM: 'waveform'
}

export const SHAKE_AMOUNT = {
    NONE: 'none',
    LITTLE: 'little',
    LOT: 'lot'
}

// Maps the legacy discrete rumble values onto the 0-100 intensity slider, using the exact
// equivalents of the old shake factors
export const LEGACY_SHAKE_AMOUNT_INTENSITY = {
    [SHAKE_AMOUNT.NONE]: 0,
    [SHAKE_AMOUNT.LITTLE]: 20,
    [SHAKE_AMOUNT.LOT]: 32,
}

export const shakeAmountToIntensity = (shakeAmount) =>
    LEGACY_SHAKE_AMOUNT_INTENSITY[shakeAmount] ?? 20;

export const FONT = {
    MONTSERRAT: 'Montserrat',
    ORBITRON: 'Orbitron',
    MERRIWEATHER: 'Merriweather',
    PERMANENT_MARKER: 'PermanentMarker',
    AUDIOWIDE: 'Audiowide',
    CREEPSTER: 'Creepster',
    DANCING_SCRIPT: 'DancingScript',
    EATER: 'Eater',
    FREDERICKA_THE_GREAT: 'FrederickatheGreat',
    INDIE_FLOWER: 'IndieFlower',
    LIBRE_BARCODE_39_TEXT: 'LibreBarcode39Text',
    MODAK: 'Modak',
    NOSIFER: 'Nosifer',
    OSWALD: 'Oswald',
    PACIFICO: 'Pacifico',
    PRESS_START_2P: 'PressStart2P',
    ROBOTO: 'Roboto',
    RUBIK_MONO_ONE: 'RubikMonoOne',
}

export const FONT_SOURCE = {
    SYSTEM: 0,
    GOOGLE_FONTS: 1
}

export const PARTICLE_DIRECTIONS = {
    OUT: 'OUT',
    IN: 'IN',
    DOWN: 'DOWN',
    UP: 'UP',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    FLOCK: 'FLOCK',
}

export const TEXT_ANCHOR_POINTS = {
    CENTER: 'CENTER',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
}

export const PREVIEW_RESOLUTION = {
    TWO_FORTY: 240,
    THREE_SIXTY: 360,
    FOUR_EIGHTY: 480,
    SEVEN_TWENTY: 720,

    PREVIEW_RESOLUTION_STORAGE_KEY: 'PREVIEW_RESOLUTION_STORAGE_KEY',
};

export const REFLECTION_TYPE = {
    NONE: 'none',
    VERTICAL: 'vertical',
    SLANTED: 'slanted',
    THREE_WAY: 'three way',
    FOUR_WAY: 'four way',
    ONE_SIDE: '1 side',
    TWO_SIDE: '2 sides',
    COMBO: 'combo',
}

// Bar count step based on reflection type
export const BAR_COUNT_STEP = {
    [REFLECTION_TYPE.NONE]: 1,
    [REFLECTION_TYPE.VERTICAL]: 2,
    [REFLECTION_TYPE.SLANTED]: 2,
    [REFLECTION_TYPE.THREE_WAY]: 3,
    [REFLECTION_TYPE.FOUR_WAY]: 4,
    [REFLECTION_TYPE.ONE_SIDE]: 2,
    [REFLECTION_TYPE.TWO_SIDE]: 1,
    [REFLECTION_TYPE.COMBO]: 2
};

export const MIN_BAR_COUNT = {
    [REFLECTION_TYPE.NONE]: 4,
    [REFLECTION_TYPE.VERTICAL]: 4,
    [REFLECTION_TYPE.SLANTED]: 4,
    [REFLECTION_TYPE.THREE_WAY]: 6,
    [REFLECTION_TYPE.FOUR_WAY]: 4,
    [REFLECTION_TYPE.ONE_SIDE]: 4,
    [REFLECTION_TYPE.TWO_SIDE]: 4,
    [REFLECTION_TYPE.COMBO]: 4,
};

export const MAX_BAR_COUNT = {
    [REFLECTION_TYPE.NONE]: 200,
    [REFLECTION_TYPE.VERTICAL]: 200,
    [REFLECTION_TYPE.SLANTED]: 200,
    [REFLECTION_TYPE.THREE_WAY]: 198,
    [REFLECTION_TYPE.FOUR_WAY]: 200,
    [REFLECTION_TYPE.ONE_SIDE]: 200,
    [REFLECTION_TYPE.TWO_SIDE]: 200,
    [REFLECTION_TYPE.COMBO]: 200,
};

export const VISUALIZER_SHAPE = {
    FLAT: 'flat',
    CIRCLE: 'circle'
}

export const LAYOUT_TYPE = {
    WEBBED: 'webbed',
    LAYERED: 'layered',
    STACKED: 'stacked',
    TARGET: 'target'
}

export const GLOW_TYPE = {
    NONE: 'none',
    INNER: 'inner',
    OUTER: 'outer'
}

export const BASS_SPECTRUM_OPTIONS = {
    smoothingPoints: CONSTANTS.BASS_SMOOTHING_POINTS,
    smoothingPasses: 4,
    maxShiftPasses: 0,
    smoothed: true,
};

export const CORNER_POSITION = {
    TOP: 0,
    TOP_RIGHT: 1,
    RIGHT: 2,
    BOTTOM_RIGHT: 3,
    BOTTOM: 4,
    BOTTOM_LEFT: 5,
    LEFT: 6,
    TOP_LEFT: 7
};

export const REFLECTION_DIRECTION_TWO_WAY = {
    FROM_TOP_TO_BOTTOM: 0,
    FROM_LEFT_TO_RIGHT: 1,
    FROM_BOTTOM_TO_TOP: 2,
    FROM_RIGHT_TO_LEFT: 3
}


export const REFLECTION_DIRECTION_FOUR_WAY = {
    LEFT_TOP_CORNER: 0,
    RIGHT_TOP_CORNER: 1,
    RIGHT_BOTTOM_CORNER: 2,
    LEFT_BOTTOM_CORNER: 3,
}

export const BACKGROUND_REFLECTION_TYPE = {
    NONE: 0,
    TWO_WAY: 1,
    FOUR_WAY: 2
}

export const CORNER_POSITION_OPTIONS = [
    {value: CORNER_POSITION.TOP, text: 'Top'},
    {value: CORNER_POSITION.TOP_RIGHT, text: 'Top Right'},
    {value: CORNER_POSITION.RIGHT, text: 'Right'},
    {value: CORNER_POSITION.BOTTOM_RIGHT, text: 'Bottom Right'},
    {value: CORNER_POSITION.BOTTOM, text: 'Bottom'},
    {value: CORNER_POSITION.BOTTOM_LEFT, text: 'Bottom Left'},
    {value: CORNER_POSITION.LEFT, text: 'Left'},
    {value: CORNER_POSITION.TOP_LEFT, text: 'Top Left'}
];

// The size of animation frames according to max resolution
export const YOUTUBE_CTA_CONFIG = {
    WIDTH: 240, 
    HEIGHT: 120,
    SPEED: 0.6,

    FRAMES_LOCATION: 'https://specterr.b-cdn.net/YouTube%20CTA%20720_{FRAME}.png',
    FRAME_NUMBER_KEY: '{FRAME}',
    FIRST_FRAME_NUMBER: 0,
    LAST_FRAME_NUMBER: 598,
    STATIC_FRAME_NUMBER: 190
};

// Every element on the canvas is authored against a frame this many units tall, whatever the preview
// resolution or the aspect ratio: the text elements, the image elements and the visualizer all store
// their position in these units, measured from the middle of the frame. It is what lets one drag
// controller move any of them without knowing which it is holding.
export const PREVIEW_BASE_HEIGHT = 500;

export const IMAGE_ELEMENT_CONFIG = {
    // Positions, sizes and shadows of an image element are authored against the shared base frame, so
    // a picture lands where it was placed at every preview resolution. The export renderer keeps the
    // same base in IMAGE_ELEMENT_BASE_SETTINGS.
    BASE_HEIGHT: PREVIEW_BASE_HEIGHT,

    // Every image is first fitted inside a square box of this many base units, keeping its own
    // aspect ratio, so a portrait photo and a wide banner start out equally prominent. The Size
    // controls grow or shrink it from there. The box is 40% of the frame height.
    BOX_SIZE: 200,

    // DropShadowFilter blurs with a Kawase approximation, whose passes show as rectangular steps in
    // the shadow once the blur is wide. This matches the value the visualizer already uses.
    SHADOW_QUALITY: 10
};

// The editor chrome drawn over the element under the pointer: the bounding indicator, and the four
// corner squares that resize it. Alternating red and white lines were asked for so the outline reads
// over a dark photo and a pale one alike, which a single colour never manages on both.
//
// Only an image element carries the corner squares. Text and the visualizer are dragged but never
// resized, so for them the outline is drawn on its own.
export const CANVAS_ELEMENT_HIGHLIGHT = {
    LINE_COLOR: '#ef1b2d',
    ALTERNATE_LINE_COLOR: '#ffffff',

    // Thickness of the outline, and the length of one red or one white segment along it. A hairline
    // marks the edge of the picture without covering the pixels the user is trying to line up.
    LINE_THICKNESS: 1,
    LINE_SEGMENT_LENGTH: 6,

    // Side of a corner square, and the white ring drawn around its red fill.
    HANDLE_SIZE: 10,
    HANDLE_BORDER_THICKNESS: 2
};

// Magnetic alignment while an element is dragged around the canvas, and the guide lines that show
// which line it has caught on.
export const CANVAS_ELEMENT_SNAPPING = {
    // How near an edge has to come before it is pulled onto a line, measured in screen pixels rather
    // than renderer ones: what makes a snap feel right is how far the hand moved, and the renderer
    // grid is a different size at every preview resolution and window width.
    DISTANCE_IN_SCREEN_PIXELS: 8,

    // The safe zone is inset from every edge by the same number of base units, so the gap a picture
    // parks at looks identical whatever the frame's shape. Scaling the frame instead, which is what
    // this did first, made the side margin grow with the width: 44 units at the sides against 25 at
    // the top in a 16:9 frame, which reads as a mistake rather than a margin.
    //
    // The number itself is the Like & Subscribe badge's own margin, so a picture parked on the safe
    // zone lines up with the badge instead of sitting on a second, competing margin. That margin is
    // not a constant anywhere: getYouTubeCtaPosition puts the badge's box flush in the corner, at
    // 0,0, and the gap a viewer sees is the transparent border drawn into the artwork. Measured off
    // the frames the CDN serves, which are 426 x 213 and stretched onto a box of
    // YOUTUBE_CTA_CONFIG.WIDTH x HEIGHT (240 x 120) at a 720-tall preview:
    //
    //   sides: 48 px of 426 -> 48 * (240 / 426) / (720 / 500) = 18.8 base units
    //   top:   49 px of 213 -> 49 * (120 / 213) / (720 / 500) = 19.2 base units
    //
    // The badge is scaled by the frame's height alone, so those hold in every aspect ratio. 19 is
    // the whole number both round to. Re-measure with playground/Add-Images/harness/snap-geometry-check.js
    // if the artwork is ever redrawn.
    SAFE_ZONE_MARGIN: 19,

    // A guide is a hairline: it marks a line without covering the picture it is aligning.
    GUIDE_THICKNESS: 1
};

// Picking an element up off the canvas.
export const CANVAS_ELEMENT_DRAG = {
    // The smallest an element's grab area is allowed to be on either axis, in base units. A flat wave
    // over a quiet passage is drawn as a line a couple of units thick, and a single line of small text
    // is barely taller; either would be impossible to catch at its true size. Kept well under the
    // safe zone margin so an element grown to the minimum still cannot swallow its neighbours.
    MINIMUM_GRAB_SIZE: 24
};

// Font fallback definitions for multilingual text support
export const FONT_FALLBACKS = {
    // Primary fallback fonts that have good support for Latin characters
    PRIMARY_FALLBACKS: [
        'Arial',
        'Noto Sans'
    ],

    // Specialized fonts for CJK (Chinese, Japanese, Korean) character support
    CJK_FONTS: [
        'Noto Sans CJK SC',
        'Noto Sans CJK TC',
        'Microsoft YaHei',
        'SimHei'
    ],

    // Sinhala script fallback font
    SINHALA_FONTS: [
        'Noto Sans Sinhala'
    ]
};